import React, { useState } from 'react';
import { Eye, EyeSlash, Lock } from '@phosphor-icons/react';
import './AccountModal.scss';
import Spinner from '../../../Spinner.js';
import Pool from '../../../../UserPool.js'

export default function ChangePassword(props) {
    const { 
        setModal 
    } = props;

    const [loading, setLoading] = useState(false);
    const [successMessage, setSuccessMessage] = useState(false);
    const [error, setError] = useState(false);
    const [currentPassword, setCurrentPassword] = useState('');
    const [newPassword, setNewPassword] = useState('');
    const [showCurrentPassword, setShowCurrentPassword] = useState(false);
    const [showNewPassword, setShowNewPassword] = useState(false);

    const changePasswordHelper = (oldPassword, newPassword) => {
        return new Promise((resolve, reject) => {
          const user = Pool.getCurrentUser();
      
          if (!user) {
            return reject(new Error("User not logged in."));
          }
      
          user.getSession((err, session) => {
            if (err) {
              return reject(err);
            }
      
            user.changePassword(oldPassword, newPassword, (err, result) => {
              if (err) {
                return reject(err);
              }
      
              resolve(result);
            });
          });
        });
    };

    const changePassword = () => {
        setLoading(true);
        setError(false);
        if (currentPassword.length === 0 || newPassword.length === 0) {
            setLoading(false);
            setError('Please input a valid password.')
        } else {
            changePasswordHelper(currentPassword, newPassword)
            .then(() => {
                console.log('password changed');
                setLoading(false);
                setSuccessMessage('Password changed successfully.');
                setModal({
                    type: false,
                    content: null
                })
                }).catch(err => {
                    console.log('error changing password');
                    setLoading(false);
                    setError(err.message);
            });
        }
    }

    return (
        <div className='account-modal'>
            <div className='account-modal-title'>Change Password</div>
            <div className='account-modal-content-inputs'>
                <div className='account-modal-content-inputs-input-container'>
                    <div className='account-modal-content-inputs-input-container-title'>Current Password</div>
                    <div className='account-modal-content-inputs-input-container-field'>
                        <Lock size={20} weight="bold" />
                        <input 
                            type={showCurrentPassword ? 'text' : 'password'} 
                            className='account-modal-content-inputs-input-container-input'
                            value={currentPassword}
                            onChange={(e) => setCurrentPassword(e.target.value)}
                            placeholder='Enter current password'
                        />
                        <div 
                            onClick={() => setShowCurrentPassword(!showCurrentPassword)} 
                            className='account-modal-content-inputs-input-container-eye'
                        >
                            {showCurrentPassword ? <EyeSlash size={20} /> : <Eye size={20} />}
                        </div>
                    </div>
                </div>
                <div className='account-modal-content-inputs-input-container'>
                    <div className='account-modal-content-inputs-input-container-title'>New Password</div>
                    <div className='account-modal-content-inputs-input-container-field'>
                        <Lock size={20} weight="bold" />
                        <input 
                            type={showNewPassword ? 'text' : 'password'} 
                            className='account-modal-content-inputs-input-container-input'
                            value={newPassword}
                            onChange={(e) => setNewPassword(e.target.value)}
                            placeholder='Enter new password'
                        />
                        <div 
                            onClick={() => setShowNewPassword(!showNewPassword)} 
                            className='account-modal-content-inputs-input-container-eye'
                        >
                            {showNewPassword ? <EyeSlash size={20} /> : <Eye size={20} />}
                        </div>
                    </div>
                </div>
            </div>
            {error && <div className='account-modal-content-error'>{error}</div>}
            {successMessage && <div className='account-modal-content-success'>{successMessage}</div>}
            {loading ?
            <div style={{ paddingTop: '1rem' }}>
                <Spinner />
            </div>
            :
            <div className='account-modal-bottom-btns'>
                <button 
                    className='account-modal-bottom-btns-btn-cancel'
                    onClick={() => {
                        setModal({
                            type: false,
                            content: null
                        })
                    }}>
                    Cancel
                </button>
                <button 
                    className='account-modal-bottom-btns-btn-save'
                    onClick={changePassword}
                    >
                    Save Changes
                </button>
            </div>}
        </div>
    )
}